<!-- eslint-disable vue/multi-word-component-names -->

<template>
  <div class="videolist-page-wrap">
    <Header />
    <SideBar :current="'video'" />
    <div class="page-main">
      <div class="video-type-nav">
        <div class="second-nav-list">
          <a href="/publish" class="item"> 发布视频 </a>
          <a href="/video/-1" class="item focus"> 视频管理 </a>
        </div>
        <div class="search">
          <el-input
            v-model="searchWord"
            placeholder="搜索视频标题"
            clearable
            class="m-input small list-search-input"
            @keyup.enter.native="search()"
            @clear="search()"
          >
            <i
              slot="suffix"
              v-show="searchWord == ''"
              class="el-input__icon search-icon"
            >
              <svg class="icon my-icon" aria-hidden="true">
                <use xlink:href="#icon-sousuo"></use>
              </svg>
            </i>
          </el-input>
        </div>
      </div>
      <div class="nav-line"></div>
      <!-- <p class="list-count">共{{ total }}条内容</p> -->
      <div class="list-toolbar">
        <div class="third-nav-list">
          <template v-for="(item, index) in tabs">
            <a
              :class="{ focus: curTab == item.value }"
              :key="index"
              @click="tabChange(item.value)"
            >
              {{ item.label }}
            </a>
          </template>
        </div>
        <div v-if="curTab === 5" class="draft-toolbar-actions">
          <el-button
            class="draft-export-btn"
            type="primary"
            size="small"
            :loading="exporting"
            @click="exportDrafts"
            >下载</el-button
          >
          <el-button
            class="draft-export-btn"
            type="primary"
            size="small"
            :loading="importing"
            @click="pickDraftImport"
            >导入</el-button
          >
          <input
            ref="draftImportInput"
            class="draft-import-input"
            type="file"
            accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            @change="importDrafts"
          />
        </div>
      </div>
      <div v-loading="firstLoading">
        <div class="lists-wrap" v-if="dataList.length > 0">
          <div
            class="video-lists"
            :infinite-scroll-distance="180"
            v-infinite-scroll="debouncedLoadMore"
            :infinite-scroll-disabled="!hasNext"
          >
            <template v-for="(item, index) in dataList">
            <div
              class="video-item draft-edit"
              v-if="curTab === 5"
              :key="'draft-' + item.id"
            >
              <div class="left">
                <div class="cover" @click="previewVideo(item)">
                  <span class="play-icon"></span>
                  <img
                    class="img-fill"
                    v-if="item.videoResp?.videoCover"
                    :src="item.videoResp?.videoCover"
                  />
                  <img v-else src="@/assets/images/no-cover.png" class="" />
                  <div class="mask"></div>
                </div>
                <div class="draft-form">
                  <div class="draft-field">
                    <label>标题</label>
                    <el-input
                      class="m-input"
                      maxlength="30"
                      v-model="item.editTitle"
                      placeholder="视频标题 5-30个字符"
                    ></el-input>
                  </div>
                  <div class="draft-field">
                    <label>关联话题</label>
                      <TopicSelect
                        v-model="item.editTopics"
                        :options="topicList"
                        @add="insertDraftTopic(item, $event)"
                      />
                  </div>
                  <div class="draft-field">
                    <label>投稿活动</label>
                      <el-select
                        clearable
                        v-model="item.editActivityId"
                        placeholder="请选择投稿活动"
                      >
                        <el-option
                          v-for="act in activityList"
                          :key="act.id"
                          :label="act.name"
                          :value="act.id"
                        />
                      </el-select>
                  </div>
                  <div class="draft-field">
                    <label>正文</label>
                    <div
                      class="draft-content-editor"
                      contenteditable="true"
                      :data-draft-id="item.id"
                      @input="onDraftContentInput(item, $event)"
                      @blur="saveDraftSelection(item)"
                    ></div>
                    <p
                      class="draft-content-count"
                      :class="{ 'c-red': (item.editContent || '').length > 500 }"
                    >
                      {{ (item.editContent || '').length }}/500
                    </p>
                  </div>
                  <div class="draft-field">
                    <label>关联文物</label>
                    <el-select
                      class="collection-select"
                      v-model="item.editCollectionIds"
                      placeholder="请选择关联文物"
                      multiple
                      filterable
                      remote
                      popper-class="collection-dropdown"
                      :remote-method="fetchCollection"
                      @visible-change="onCollectionVisible"
                    >
                      <el-option
                        v-for="collect in collectionList"
                        :key="collect.collectInfo.id"
                        :label="collect.collectInfo.title"
                        :value="collect.collectInfo.id"
                        class="collection-option"
                      >
                        <div class="item">
                          <img
                            :src="collect.collectInfo.image && collect.collectInfo.image.url"
                            class="image"
                          />
                          <div class="info">
                            <a
                              class="name text-overflow-2"
                              :title="collect.collectInfo.title"
                              >{{ collect.collectInfo.title }}</a
                            >
                          </div>
                        </div>
                      </el-option>
                    </el-select>
                  </div>
                  <div class="draft-field">
                    <label>内容标签</label>
                    <ContentTagSelect v-model="item.editContentTags" />
                  </div>
                  <div class="draft-field">
                    <label>AI创作者声明</label>
                    <el-checkbox v-model="item.editUseAI"
                      >视频创作中使用了AI工具，添加AI内容生产标识</el-checkbox
                    >
                  </div>
                  <div class="draft-field">
                    <div class="agree-protocol">
                      <el-checkbox class="m-checkbox" v-model="item.editAgreed"
                        >我已阅读并接受</el-checkbox
                      ><a
                        target="_blank"
                        href="https://omgotv.mgtv.com/protocol/SH_creator_covenant"
                        >《山海社区公约》</a
                      >
                    </div>
                  </div>
                  <div class="date" v-if="item.pubTime">
                    保存时间: {{ item.pubTime }}
                  </div>
                </div>
              </div>
              <div class="right m-btn">
                <el-button
                  class="normal-btn edit"
                  type="primary"
                  :loading="item.publishing"
                  :disabled="item.saving"
                  @click="publishDraftRow(index, item)"
                >
                  <span class="text">发布</span>
                </el-button>
                <el-button
                  class="normal-btn edit"
                  type="primary"
                  :loading="item.saving"
                  :disabled="item.publishing"
                  @click="saveDraftRow(item)"
                >
                  <span class="text">保存</span>
                </el-button>
                <el-button class="normal-btn edit" type="primary">
                  <a :href="`/edit/${item.id}/${curTab}`">
                    <svg class="icon my-icon" aria-hidden="true">
                      <use xlink:href="#icon-bianji"></use>
                    </svg>
                    <span class="text">编辑</span>
                  </a>
                </el-button>
                <el-button
                  class="normal-btn del"
                  @click="deleteDraft(index, item)"
                >
                  <span class="text">删除</span>
                </el-button>
              </div>
            </div>
            <a
              class="video-item"
              v-else
              :key="index"
            >
              <div class="left">
                <div class="cover" @click="previewVideo(item)">
                  <span class="play-icon"></span>
                  <img
                    class="img-fill"
                    v-if="item.videoResp?.videoCover"
                    :src="item.videoResp?.videoCover"
                  />
                  <img v-else src="@/assets/images/no-cover.png" class="" />
                  <div class="mask"></div>
                  <!-- <span class="time">{{$utils.formatTime(item.videoResp.duration)}}</span> -->
                </div>
                <!-- ing success -->
                <div
                  class="des"
                  v-if="curTab !== 5"
                  :class="statusMap[item.status].status"
                >
                  <div class="status">{{ statusMap[item.status].text }}</div>
                  <h4 class="title text-overflow">{{ item.title }}</h4>
                  <!-- <div class="videoid" v-if="item.videoResp?.videoId">
                    视频ID: {{ item.videoResp?.videoId }}
                  </div> -->
                  <div class="date">保存时间: {{ item.pubTime }}</div>
                </div>
                <div class="des" v-else :class="ing">
                  <h4 class="title text-overflow" v-if="item.title">
                    {{ item.title }}
                  </h4>
                  <h4 class="title text-overflow" v-else>&nbsp;&nbsp;</h4>
                  <div class="date" v-if="item.pubTime">
                    保存时间: {{ item.pubTime }}
                  </div>
                </div>
              </div>
              <div class="right m-btn">
                <!-- v-if="item.status === 2 || curTab === 5" -->
                <el-button
                  v-if="curTab === 5"
                  class="normal-btn edit"
                  type="primary"
                >
                  <a :href="`/edit/${item.id}/${curTab}`">
                    <svg class="icon my-icon" aria-hidden="true">
                      <use xlink:href="#icon-bianji"></use>
                    </svg>
                    <span class="text">编辑</span>
                  </a>
                </el-button>

                <!-- <el-button v-else class="normal-btn edit" type="primary" disabled>
                  <svg class="icon my-icon" aria-hidden="true">
                    <use xlink:href="#icon-bianji"></use>
                  </svg>
                  <span class="text">编辑</span>
                </el-button> -->

                <!-- isPrivate 1私有 0公开 -->
                <el-button
                  v-if="curTab !== 5"
                  class="normal-btn private"
                  @click="privateVideo(index, item)"
                >
                  <span class="text"
                    >设为{{ item.isPrivate ? '公开' : '私密' }}</span
                  >
                </el-button>

                <el-button
                  class="normal-btn del"
                  v-if="curTab == 5"
                  @click="deleteDraft(index, item)"
                >
                  <span class="text">删除</span>
                </el-button>
                <el-button
                  class="normal-btn del"
                  v-else
                  @click="deleteVideo(index, item)"
                >
                  <span class="text">删除</span>
                </el-button>
              </div>
            </a>
            </template>
            <p class="scroll-text" v-if="page > 1 && loading">加载中...</p>
            <p class="scroll-text" v-if="!hasNext">没有更多了</p>
          </div>
        </div>

        <div class="list-no-data" v-if="dataList.length == 0">
          <p class="no"><img src="@/assets/images/list-no-data.png" /></p>
          <p v-if="curTab != -1">无符合条件的视频</p>
          <p v-else>你还没有发布过视频～</p>
          <el-button
            type="primary"
            v-if="curTab == -1"
            class="m-btn add-video-btn"
            @click="$router.push({ path: '/publish' })"
            ><svg class="icon my-icon" aria-hidden="true">
              <use xlink:href="#icon-a-shangchuan2x"></use></svg
            ><span class="text">发布视频</span></el-button
          >
        </div>
      </div>
      <el-dialog
        class="preview-dialog"
        title="视频预览"
        :visible.sync="videoPreviewVisible"
        width="70%"
        @close="closePrevideoVideo()"
      >
        <video ref="videoPlayer" class="video" controls autoplay height="450">
          <source :src="videoPlayUrl" />
        </video>
        <span slot="footer" class="dialog-footer">
          <el-button @click="closePrevideoVideo()">关闭</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
/*eslint-disable*/
import Header from '@/components/Header.vue';
import ContentTagSelect from '@/components/ContentTagSelect.vue';
import TopicSelect from '@/components/TopicSelect.vue';
import {
  getVideoList,
  deleteVideo,
  deleteDraft,
  getMyDraftList,
  exportDraftExcel,
  importDraftExcel,
  setPrivate,
  getVideoDetail,
  getDraftDetail,
  getVideoSource,
  getTopicList,
  getActivityList,
  getCollectList,
  editDraft,
  publishDraft,
} from '@/servies/index.js';
import _ from 'lodash';
import Hls from 'hls.js';
import jsonp from 'jsonp';
import SideBar from '@/components/SideBar.vue';

export default {
  data() {
    return {
      hls: null,
      videoPreviewVisible: false,
      videoPlayUrl: '',
      debouncedLoadMore: _.debounce(this.load, 500),
      firstLoading: true,
      hasNext: true,
      curTab: -1,
      loading: false,
      page: 1,
      pageSize: 15,
      total: 0,
      dataList: [],
      totalPage: 0,
      statusMap: {
        // 审核状态。0-审核中；1-审核通过；2-审核失败
        0: {
          text: '审核中',
          value: 0,
          status: 'ing',
        },
        1: {
          text: '审核通过',
          status: 'success',
          value: 1,
        },
        2: {
          text: '审核失败',
          status: 'failure',
          value: 1,
        },
      },
      tabs: [
        { label: '全部', value: -1 },
        { label: '已上线', value: 1 },
        { label: '审核中', value: 2 },
        { label: '审核失败', value: 3 },
        { label: '仅我可见', value: 4 },
        { label: '草稿', value: 5 },
      ],
      searchWord: '',
      userInfo: null,
      topicList: [],
      activityList: [],
      collectionList: [],
      draftOptionsReady: null,
      exporting: false,
      importing: false,
    };
  },
  components: {
    Header,
    SideBar,
    ContentTagSelect,
    TopicSelect,
  },
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem('sh-userInfo'));
    console.log(this.userInfo);
  },
  async created() {
    this.draftSelections = {};
    const status = this.$route.params.status;
    if (typeof status != 'undefined') {
      this.curTab = parseInt(status);
    } else {
      this.curTab = -1;
    }
    this.load();
  },
  computed: {
    disabled() {
      // 没有下一页了 true
      return this.hasNext;
    },
  },

  methods: {
    // 组件销毁时取消防抖
    beforeDestroy() {
      if (this.debouncedLoadMore?.cancel) {
        this.debouncedLoadMore.cancel(); // Lodash 的防抖取消
      }
    },
    closePrevideoVideo() {
      const video = this.$refs.videoPlayer;
      if (video) {
        video.pause(); // 暂停视频
        if (this.hls) {
          this.hls.destroy(); // 销毁HLS实例
          this.hls = null;
        }
      }
      this.videoPreviewVisible = false;
    },
    previewVideo(item) {
      if (this.curTab == 5) {
        // 草稿有视频预览地址
        this.fetchDraftDetail(item);
      } else {
        // 正式片只有视频ID
        this.fetchDetail(item);
      }
    },
    fetchDetail(item) {
      getVideoDetail({
        id: item.id,
      }).then((res) => {
        let response = res.data;
        if (response.code == 200 && response.data.contents.length > 0) {
          if (response.data.contents[0].videoResp.videoTmpUrl) {
            this.videoPlayUrl = response.data.contents[0].videoResp.videoTmpUrl;
            this.videoPreviewVisible = true;
            this.$nextTick(() => {
              this.$refs.videoPlayer.load();
            });
          } else if (response.data.contents[0].videoResp.videoId) {
            //this.$message({
            //message: '功能升级，请稍晚一些使用',
            //type: 'error',
            //});
            let vid = response.data.contents[0].videoResp.videoId;
            // 走世龙接口取流
            // window.open(`https://www.mgtv.com/s/${vid}.html?from=szwb`);
            this.videoSource(vid);
          }
        }
      });
    },
    videoSource(videoId) {
      getVideoSource({
        videoId: videoId,
        playType: 43,
        terminal: 4,
        sh: 1,
      })
        .then((res) => {
          let response = res.data;
          if (response.code == 200 && response.data) {
            let data = response.data;
            let currentQuality = data.streamQuality.currentQuality; // currentQuality 标识当前哪一路清晰度是快起
            let videoSources = data.videoSources;
            let matchingSource = videoSources.find(
              (source) => source.definition == currentQuality
            ); // 遍历找definition匹配currentQuality的那一路
            let sourceUrl = `${matchingSource.url}&sh=1`; // 三层取流地址

            jsonp(
              $utils.ensureHttps(sourceUrl),
              { name: 'callback', timeout: 10000 },
              (err, data) => {
                if (err) {
                  this.$message({
                    message: '三层取流地址请求失败',
                    type: 'error',
                  });
                  console.error(err);
                } else {
                  if (data.info) {
                    this.videoPlayUrl = data.info;
                    this.videoPreviewVisible = true;

                    this.$nextTick(() => {
                      const video = this.$refs.videoPlayer;
                      if (Hls.isSupported()) {
                        this.hls = new Hls({
                          debug: false,
                          enableWorker: true,
                        });
                        this.hls.loadSource(this.videoPlayUrl);
                        this.hls.attachMedia(video);
                        this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
                          video.play();
                        });

                        // Add error handling for HLS
                        this.hls.on(Hls.Events.ERROR, (event, data) => {
                          console.error('HLS error:', data);
                          if (data.fatal) {
                            switch (data.type) {
                              case Hls.ErrorTypes.NETWORK_ERROR:
                                this.$message({
                                  message: '视频加载失败，请检查网络连接',
                                  type: 'error',
                                });
                                break;
                              case Hls.ErrorTypes.MEDIA_ERROR:
                                this.$message({
                                  message: '视频播放失败，请稍后重试',
                                  type: 'error',
                                });
                                break;
                              default:
                                this.$message({
                                  message: '视频播放出错，请稍后重试',
                                  type: 'error',
                                });
                                break;
                            }
                          }
                        });
                      }
                      // For browsers that natively support HLS (like Safari)
                      else if (
                        video.canPlayType('application/vnd.apple.mpegurl')
                      ) {
                        video.src = this.videoPlayUrl;
                        video.addEventListener('loadedmetadata', () => {
                          video.play();
                        });
                      } else {
                        this.$message({
                          message: '您的浏览器不支持播放此视频格式',
                          type: 'error',
                        });
                      }
                    });
                  } else {
                    this.$message({
                      message: '未找到匹配的视频清晰度，请稍后重试',
                      type: 'error',
                    });
                  }
                }
              }
            );
          } else {
            this.$message({
              message: response.msg || '获取视频信息失败，请稍后重试',
              type: 'error',
            });
          }
        })
        .catch((error) => {
          console.error('Video source error:', error);
          this.$message({
            message: '获取视频信息失败，请稍后重试',
            type: 'error',
          });
        });
    },
    fetchDraftDetail(item) {
      getDraftDetail({
        id: item.id,
      }).then((res) => {
        let response = res.data;
        console.log(response);
        if (
          response.code == 200 &&
          response.data &&
          response.data.videoResp.videoTmpUrl
        ) {
          this.videoPlayUrl = response.data.videoResp.videoTmpUrl;
          this.videoPreviewVisible = true;
          this.$nextTick(() => {
            this.$refs.videoPlayer.load();
          });
        }
      });
    },
    tabChange(v) {
      if (this.curTab == v) return;
      this.curTab = parseInt(v);
      this.firstLoading = true;
      this.page = 1;
      this.dataList = [];
      this.$router.push({ path: '/video/' + v }, () => {});
      this.load();
    },
    async load() {
      if (this.loading) return;
      this.loading = true;
      try {
        // auditStatus  审核状态。0-待审核；1-审核通过；2-审核中；3-审核失败
        // onlineStatus 上线状态。0-未上线；1-已上线
        // isPrivate    是否设私： 0-设置公开； 1-设置私有
        let params = {};
        switch (this.curTab) {
          case -1: // 全部
            params = { page: this.page, isVideoType: 1 };
            break;

          case 1: // 已上线
            params = { page: this.page, onlineStatus: 1, isVideoType: 1 };
            break;

          case 2: // 审核中
            params = { page: this.page, auditStatus: 0, isVideoType: 1 };
            break;

          case 3: // 未通过
            params = { page: this.page, auditStatus: 3, isVideoType: 1 };
            break;

          case 4: // 仅我可见
            params = { page: this.page, isPrivate: 1, isVideoType: 1 };
            break;

          case 5: // 草稿
            params = { page: this.page, isVideoType: 1 };
            break;

          default: // 兜底逻辑
            params = { page: this.page, isVideoType: 1 };
        }
        params.title = this.searchWord;
        // 草稿列表查询接口
        if (this.curTab == 5) {
          getMyDraftList(params)
            .then((response) => {
              const { code, msg } = response.data;
              if (code === 200) {
                if (response.data.data.contents) {
                  const drafts = response.data.data.contents.map((item) =>
                    this.decorateDraft(item)
                  );
                  this.dataList = [...this.dataList, ...drafts];
                  this.ensureDraftOptions().then(() => {
                    drafts.forEach((item) => this.hydrateDraft(item));
                  });
                }
                this.hasNext = response.data.data.hasNext;
                this.loading = false;
                if (this.page === 1) {
                  this.firstLoading = false;
                }
                this.page++;
              } else {
                this.$message({
                  message: msg,
                  type: 'error',
                });
                this.loading = false;
              }
            })
            .catch((error) => {
              // 这里能捕获 402、404、500 等所有非 2xx 的 HTTP 错误
              if (error.response) {
                // 服务器有响应，error.response.status 就是状态码
                this.$message({
                  message: error.response.data.msg,
                  type: 'error',
                });
                setTimeout(() => {
                  this.$utils.clearLoginUserCookie();
                  window.location.href = '/login';
                }, 1000);
              } else {
                // 服务器无响应或网络错误
                this.$message({
                  message: '网络异常或服务器无响应',
                  type: 'error',
                });
                setTimeout(() => {
                  this.$utils.clearLoginUserCookie();
                  window.location.href = '/login';
                }, 1000);
              }
              console.error(error);
            });
        } else {
          getVideoList(params)
            .then((response) => {
              const { code, msg } = response.data;
              if (code === 200) {
                if (response.data.data.contents) {
                  this.dataList = [
                    ...this.dataList,
                    ...response.data?.data?.contents,
                  ];
                }
                this.hasNext = response.data.data.hasNext;
                this.loading = false;
                if (this.page === 1) {
                  this.firstLoading = false;
                }
                this.page++;
              } else {
                this.$message({
                  message: msg,
                  type: 'error',
                });
                this.loading = false;
              }
            })
            .catch((error) => {
              // 这里能捕获 402、404、500 等所有非 2xx 的 HTTP 错误
              if (error.response) {
                // 服务器有响应，error.response.status 就是状态码
                this.$message({
                  message: error.response.data.msg,
                  type: 'error',
                });
                setTimeout(() => {
                  this.$utils.clearLoginUserCookie();
                  window.location.href = '/login';
                }, 1000);
              } else {
                // 服务器无响应或网络错误
                this.$message({
                  message: '网络异常或服务器无响应',
                  type: 'error',
                });
                setTimeout(() => {
                  this.$utils.clearLoginUserCookie();
                  window.location.href = '/login';
                }, 1000);
              }
              console.error(error);
            });
        }
      } catch (error) {
        console.log(error);
      }
    },
    privateVideo(index, item) {
      let text = `确定将此视频设置成${item.isPrivate ? '公开' : '私密'}吗？`;
      this.$confirm(``, text, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true,
      })
        .then(async () => {
          setPrivate({
            feedId: item.id,
            isPrivate: Number(!item.isPrivate),
          }).then((response) => {
            const { code, msg } = response.data;
            if (code === 200) {
              this.$message({
                message: '操作成功',
                type: 'success',
              });
              if (this.curTab == 4) {
                this.dataList.splice(index, 1);
              } else {
                this.dataList[index].isPrivate = !item.isPrivate;
              }
            } else {
              this.$message({
                message: msg,
                type: 'error',
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作',
          });
        });
    },
    deleteDraft(index, item) {
      let text = `确定删除此草稿吗？`;
      // if (item.checkState === 0) text = `确定删除此条草稿吗？`
      this.$confirm(``, text, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true,
      })
        .then(async () => {
          deleteDraft({ id: item.id }).then((response) => {
            console.log(response);
            const { code, msg } = response.data;
            if (code === 200) {
              this.$message({
                message: '操作成功',
                type: 'success',
              });
              this.dataList.splice(index, 1);
            } else {
              this.$message({
                message: msg,
                type: 'error',
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作',
          });
        });
    },
    deleteVideo(index, item) {
      let text = `确定删除此视频吗？`;
      // if (item.checkState === 0) text = `确定删除此条草稿吗？`
      this.$confirm(``, text, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true,
      })
        .then(async () => {
          deleteVideo({ id: item.id }).then((response) => {
            console.log(response);
            const { code, msg } = response.data;
            if (code === 200) {
              this.$message({
                message: '操作成功',
                type: 'success',
              });
              this.dataList.splice(index, 1);
            } else {
              this.$message({
                message: msg,
                type: 'error',
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作',
          });
        });
    },
    search() {
      this.page = 1;
      this.dataList = [];
      this.load();
      console.log('search');
    },
    ensureDraftOptions() {
      if (this.draftOptionsReady) return this.draftOptionsReady;
      this.fetchCollection('文');
      this.draftOptionsReady = Promise.all([
        getTopicList({}).then((response) => {
          if (
            response.data.code === 200 &&
            response.data.data &&
            response.data.data.contents
          ) {
            this.topicList = response.data.data.contents;
          }
        }),
        getActivityList({}).then((response) => {
          if (
            response.data.code === 200 &&
            response.data.data &&
            response.data.data.length > 0
          ) {
            this.activityList = response.data.data;
          }
        }),
      ]);
      return this.draftOptionsReady;
    },
    decorateDraft(item) {
      return {
        ...item,
        editTitle: item.title || '',
        editContent: '',
        editTopics: [],
        editActivityId: this.normalizeActivityId(item.activityId),
        editCollectionIds: this.parseCollectionIds(item.collectionIds),
        editContentTags: $utils.normalizeContentTags(item.contentTags),
        editUseAI: item.isUseAI === 1 || item.isUseAI === true,
        editAgreed: false,
        saving: false,
        publishing: false,
      };
    },
    normalizeActivityId(id) {
      if (id === undefined || id === null || id === '' || id === 0 || id === '0') {
        return '';
      }
      return id;
    },
    splitTopic(content) {
      const text = content || '';
      const match = text.match(/^#(\S+)\s*/);
      if (!match) return { topicId: '', content: text };
      const topic = this.topicList.find(
        (item) => item.topicName === match[1]
      );
      if (!topic) return { topicId: '', content: text };
      return {
        topicId: topic.topicId,
        content: text.slice(match[0].length),
      };
    },
    draftEditorEl(id) {
      return this.$el.querySelector(`[data-draft-id="${id}"]`);
    },
    renderDraftContent(item) {
      this.$nextTick(() => {
        const editor = this.draftEditorEl(item.id);
        if (!editor || document.activeElement === editor) return;
        editor.innerHTML = $utils.formatTopic(item.editContent || '');
      });
    },
    onDraftContentInput(item, event) {
      item.editContent = event.target.innerText;
      this.saveDraftSelection(item);
    },
    saveDraftSelection(item) {
      const editor = this.draftEditorEl(item.id);
      const selection = window.getSelection();
      if (!editor || !selection || selection.rangeCount === 0) return;
      const range = selection.getRangeAt(0);
      if (!editor.contains(range.startContainer)) return;
      this.draftSelections[item.id] = range.cloneRange();
    },
    insertDraftTopic(item, topic) {
      const editor = this.draftEditorEl(item.id);
      const range = $utils.insertTopicChip(
        editor,
        topic && topic.topicName,
        this.draftSelections[item.id]
      );
      if (!editor || !range) return;
      this.draftSelections[item.id] = range.cloneRange();
      item.editContent = editor.innerText;
    },
    hydrateDraft(item) {
      getDraftDetail({ id: item.id }).then((res) => {
        const response = res.data;
        if (response.code != 200 || !response.data) return;
        const data = response.data;
        item.videoResp = data.videoResp || item.videoResp;
        item.collectionIds = data.collectionIds;
        item.supplyText = data.supplyText;
        item.isUseAI = data.isUseAI;
        item.editTitle = data.title || item.editTitle;
        item.editActivityId = this.normalizeActivityId(data.activityId);
        item.editTopics = $utils.topicsFromFeed(data, this.topicList);
        item.editContent = data.content || '';
        this.renderDraftContent(item);
        item.editCollectionIds = this.parseCollectionIds(data.collectionIds);
        item.editContentTags = $utils.normalizeContentTags(
          data.contentTags || item.contentTags
        );
        item.editUseAI = data.isUseAI === 1 || data.isUseAI === true;
        this.ensureCollectionOptions(item.editCollectionIds);
      }).catch(() => {});
    },
    parseCollectionIds(value) {
      if (!value) return [];
      if (Array.isArray(value)) {
        return value.map((id) => String(id)).filter((id) => id && id !== '0');
      }
      return String(value)
        .split(',')
        .map((id) => id.trim())
        .filter((id) => id && id !== '0');
    },
    onCollectionVisible(visible) {
      if (visible) this.fetchCollection('文');
    },
    fetchCollection(query) {
      const keyword = query || '文';
      getCollectList({ q: keyword, did: this.$utils.getSTKUUID() }).then(
        (res) => {
          const response = res.data;
          if (
            response.code === 200 &&
            response.data &&
            response.data.contents &&
            response.data.contents.length > 0
          ) {
            this.mergeCollectionOptions(response.data.contents);
          }
        }
      );
    },
    mergeCollectionOptions(list) {
      const map = {};
      this.collectionList.forEach((item) => {
        if (item.collectInfo && item.collectInfo.id !== undefined) {
          map[String(item.collectInfo.id)] = item;
        }
      });
      list.forEach((item) => {
        if (item.collectInfo && item.collectInfo.id !== undefined) {
          map[String(item.collectInfo.id)] = item;
        }
      });
      this.collectionList = Object.values(map);
    },
    ensureCollectionOptions(ids) {
      ids.forEach((id) => {
        const exists = this.collectionList.some(
          (item) => String(item.collectInfo.id) === String(id)
        );
        if (exists) return;
        this.mergeCollectionOptions([
          { collectInfo: { id, title: id } },
        ]);
        this.fetchCollection(id);
      });
    },
    buildDraftRowData(item) {
      const title = (item.editTitle || '').trim();
      if (!title) {
        this.$message({ message: '标题必须填写', type: 'error' });
        return null;
      }
      if (title.length > 30) {
        this.$message({ message: '标题不超过30个字符', type: 'error' });
        return null;
      }
      const editor = this.draftEditorEl(item.id);
      const content = editor ? editor.innerText : item.editContent || '';
      item.editContent = content;
      if (content.length > 500) {
        this.$message({ message: '正文不超过500个字符', type: 'error' });
        return null;
      }
      const fileId = item.videoResp?.videoParam?.fileId;
      const fileName = item.videoResp?.videoParam?.fileName;
      if (!fileId) {
        this.$message({
          message: '视频信息还在加载，请稍后再试',
          type: 'warning',
        });
        return null;
      }
      const data = {
        title,
        content,
        isUseAI: item.editUseAI ? 1 : 0,
        supplyText: item.supplyText || '',
        topicIds: $utils.formatTopicIds(item.editTopics),
        tagIds: $utils.formatContentTagIds(item.editContentTags),
        videoInfo: {
          fileId,
          fileName,
        },
      };
      const collectionIds = (item.editCollectionIds || []).join(',');
      if (collectionIds) data.collectionIds = collectionIds;
      if (item.editActivityId) data.activityId = String(item.editActivityId);
      if (data.topicIds === null) delete data.topicIds;
      const existingCover = item.videoResp?.videoParam?.videoCover;
      if (existingCover && existingCover.imgID && existingCover.imgID !== '0') {
        data.videoInfo.videoCover = {
          imgID: existingCover.imgID,
          imgType: existingCover.imgType,
          imgHeight: existingCover.imgHeight,
          imgWidth: existingCover.imgWidth,
        };
      }
      return data;
    },
    saveDraftRow(item) {
      if (item.saving || item.publishing) return;
      const data = this.buildDraftRowData(item);
      if (!data) return;
      data.id = String(item.id);
      item.saving = true;
      editDraft(data)
        .then((response) => {
          const { code, msg } = response.data;
          item.saving = false;
          if (code === 200) {
            item.title = data.title;
            item.contentTags = (item.editContentTags || []).slice();
            this.$message({ message: '保存成功', type: 'success' });
          } else {
            this.$message({ message: msg, type: 'error' });
          }
        })
        .catch(() => {
          item.saving = false;
          this.$message({ message: '保存失败，请稍后重试', type: 'error' });
        });
    },
    publishDraftRow(index, item) {
      if (item.saving || item.publishing) return;
      if (!item.editAgreed) {
        this.$message({ message: '请同意相关协议', type: 'error' });
        return;
      }
      const data = this.buildDraftRowData(item);
      if (!data) return;
      data.feedDraftId = String(item.id);
      data.feedType = 4;
      item.publishing = true;
      publishDraft(data)
        .then((response) => {
          const { code, msg } = response.data;
          item.publishing = false;
          if (code === 200) {
            this.dataList.splice(index, 1);
            this.$message({
              message: '发布成功，正在审核',
              type: 'success',
            });
          } else {
            this.$message({ message: msg, type: 'error' });
          }
        })
        .catch(() => {
          item.publishing = false;
          this.$message({ message: '发布失败，请稍后重试', type: 'error' });
        });
    },
    pickDraftImport() {
      if (this.importing) return;
      const input = this.$refs.draftImportInput;
      if (!input) return;
      input.value = '';
      input.click();
    },
    async importDrafts(event) {
      const file = event.target.files && event.target.files[0];
      event.target.value = '';
      if (!file || this.importing) return;
      if (!/\.xlsx$/i.test(file.name)) {
        this.$message({ message: '请上传xlsx文件', type: 'warning' });
        return;
      }
      this.importing = true;
      try {
        const res = await importDraftExcel(file);
        const body = res.data || {};
        if (body.code === 200) {
          const count = body.data && body.data.successCount ? body.data.successCount : 0;
          this.$message({ message: `已导入${count}条草稿`, type: 'success' });
          this.search();
        } else {
          this.$message({ message: body.msg || '导入失败，请稍后重试', type: 'error' });
        }
      } catch (error) {
        let message = '导入失败，请稍后重试';
        const data = error && error.response && error.response.data;
        if (data && data.msg) {
          message = data.msg;
        } else if (error && error.message) {
          message = error.message;
        }
        this.$message({ message, type: 'error' });
      } finally {
        this.importing = false;
      }
    },
    async exportDrafts() {
      if (this.exporting) return;
      this.exporting = true;
      try {
        const res = await exportDraftExcel({
          isVideoType: 1,
          title: this.searchWord,
        });
        const blob = res.data;
        const contentType = (res.headers && res.headers['content-type']) || '';
        if (contentType.indexOf('application/json') !== -1 || contentType.indexOf('text/') === 0) {
          const text = await blob.text();
          let message = '导出失败，请稍后重试';
          try {
            const body = JSON.parse(text);
            message = body.msg || message;
          } catch (e) {
            if (text) message = text;
          }
          this.$message({
            message,
            type: message === '没有可导出的草稿' ? 'warning' : 'error',
          });
          return;
        }
        const now = new Date();
        const pad = (n) => String(n).padStart(2, '0');
        const stamp = `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(
          now.getDate()
        )}${pad(now.getHours())}${pad(now.getMinutes())}`;
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `视频草稿_${stamp}.xlsx`;
        link.click();
        URL.revokeObjectURL(link.href);
      } catch (error) {
        let message = '导出失败，请稍后重试';
        const data = error && error.response && error.response.data;
        if (data && typeof data.text === 'function') {
          try {
            const body = JSON.parse(await data.text());
            message = body.msg || message;
          } catch (e) {
            message = (error && error.message) || message;
          }
        } else if (error && error.message) {
          message = error.message;
        }
        this.$message({ message, type: 'error' });
      } finally {
        this.exporting = false;
      }
    },
  },
  watch: {},
};
</script>

<style lang="less" scoped>
.videolist-page-wrap {
  .page-main {
    width: 1280px;
    margin: 0 auto;
    padding-top: 100px;
  }

  .list-count {
    line-height: 40px;
    color: #b3b7c2;
  }

  .list-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .third-nav-list {
      width: auto;
      flex: 1;
    }
    .draft-toolbar-actions {
      display: flex;
      align-items: center;
      margin-left: 12px;
    }
    .draft-import-input {
      display: none;
    }
    .draft-export-btn {
      margin-left: 12px;
      background: #04cbcd;
      border-color: #04cbcd;
    }
    .draft-toolbar-actions .draft-export-btn:first-child {
      margin-left: 0;
    }
  }

  .lists-wrap {
  }
  .video-lists {
    height: calc(100vh - 200px);
    overflow: auto;
    padding-bottom: 50px;
    padding-top: 10px;
    padding-right: 32px;
    .video-item {
      display: flex;
      justify-content: space-between;
      padding: 16px;
      &:hover {
        border-radius: 8px;
        background: #f7f7f7;
        .cover {
          .img-fill,
          .mask {
            transform: scale(1.05) translateZ(0);
            transition: all 0.25s ease-in-out;
          }
        }
      }
      .left {
        display: flex;
      }
      .cover {
        width: 126px;
        height: 95px;
        position: relative;
        margin-right: 8px;
        &:hover {
          .mask,
          .play-icon {
            display: block;
          }
        }
        img {
          width: 126px;
          height: 95px;
          border-radius: 4px;
          z-index: 1;
        }

        .mask {
          display: none;
          width: 126px;
          height: 95px;
          border-radius: 4px;
          position: absolute;
          bottom: 0;
          left: 0;
          background: #000;
          opacity: 0.4;
          z-index: 2;
        }
        .play-icon {
          display: none;
          width: 30px;
          height: 30px;
          background: url('@/assets/images/play-icon.png') no-repeat;
          background-size: 30px 30px;
          position: absolute;
          z-index: 3;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
        .time {
          position: absolute;
          right: 4px;
          bottom: 2px;
          color: #fff;
          font-size: 8px;
          z-index: 3;
        }
      }
      &.draft-edit {
        align-items: flex-start;
        height: auto;
        margin-bottom: 16px;
        border: 1px solid #e5e6eb;
        border-radius: 8px;
        background: #fff;
        &:hover {
          background: #fff;
          border-color: #c9cdd4;
        }
        .left {
          flex: 1;
          min-width: 0;
        }
        .draft-form {
          flex: 1;
          min-width: 0;
          padding-right: 16px;
        }
        .draft-field {
          margin-bottom: 12px;
          label:not(.el-checkbox) {
            display: block;
            margin-bottom: 8px;
            color: #4e5969;
            font-size: 14px;
            line-height: 22px;
          }
          .agree-protocol {
            .el-checkbox {
              display: inline-block;
              width: auto;
              margin-bottom: 0;
            }
          }
          .el-select,
          .el-input,
          .el-textarea {
            width: 100%;
          }
          .draft-content-editor {
            border: 1px solid #dcdfe6;
            border-radius: 10px;
            padding: 8px;
            line-height: 24px;
            min-height: 100px;
            height: auto;
            overflow: visible;
            background: #fff;
            white-space: pre-wrap;
            word-break: break-all;
            &:focus {
              border: none;
              outline: 1px solid #04cbcd;
            }
            /deep/ .c-blue {
              color: #04cbcd;
            }
          }
          .draft-content-count {
            margin: 0;
            text-align: right;
            height: 24px;
            line-height: 24px;
            color: rgba(0, 0, 0, 0.45);
            &.c-red {
              color: red;
            }
          }
          .collection-select {
            width: 400px;
            /deep/ .el-input .el-select__caret::before {
              content: "\e6e1";
            }
            /deep/ .el-input.is-focus .el-select__caret {
              transform: rotateZ(0deg);
            }
          }
        }
        .draft-field-row {
          display: flex;
          .draft-field {
            flex: 1;
            min-width: 0;
            &:first-child {
              margin-right: 12px;
            }
          }
        }
        .date {
          color: #86909c;
          font-size: 14px;
        }
        .right {
          flex-direction: column;
          align-items: stretch;
          .normal-btn {
            margin-left: 0;
            margin-bottom: 8px;
            &.del {
              width: 80px;
            }
          }
        }
      }
      .des {
        position: relative;
        width: 560px;
        &.ing {
          .status {
            color: #04cbcd;
            border: 1px solid #04cbcd;
          }
        }
        &.failure {
          .status {
            color: rgb(251, 94, 94);
            border: 1px solid rgb(251, 94, 94);
          }
        }
        &.success {
          .status {
            color: #86909c;
            border: 1px solid #86909c;
          }
          .date {
            color: #c9cdd4;
          }
        }
        .status {
          display: inline-block;
          padding: 0 6px;
          height: 18px;
          margin-bottom: 4px;
          line-height: 18px;
          text-align: center;
          font-size: 12px;
          border-radius: 4px;
        }
        .title {
          width: 100%;
          margin-bottom: 8px;
          font-size: 15px;
          font-style: normal;
          font-weight: 600;
        }
        .videoid {
          color: #86909c;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
        }
        .date {
          position: absolute;
          bottom: 0;
          left: 0;
          color: #86909c;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
        }
      }
    }
    .m-btn {
      display: flex;
      align-items: flex-end;
      .normal-btn {
        border-radius: 4px;
        padding: 0;
        height: 34px;
        line-height: 34px;
        text-align: center;
        font-size: 14px;
        border: none;
        &:hover {
          opacity: 0.85;
        }
        &.edit {
          width: 80px;
          &.is-disabled {
            opacity: 0.5;
          }
          a {
            color: #fff;
          }
          .icon {
            margin-right: 8px;
            font-size: 14px;
          }
        }
        &.private {
          width: 88px;
          color: #4e5969;
          background: #f2f3f5;
          &:hover {
            opacity: 0.7;
          }
        }
        &.del {
          width: 60px;
          color: #4e5969;
          background: #f2f3f5;
          &:hover {
            opacity: 0.7;
          }
        }
      }
    }
  }
  .list-no-data {
    padding-top: 100px;
    width: 300px;
    margin: 0 auto;
    p {
      display: block;
      width: 100%;
      color: #93939d;
      text-align: center;
      margin-bottom: 20px;
      &.no {
        margin-bottom: -10px;
      }
    }
    .m-btn {
      display: block;
      margin: 0 auto;
      width: 170px;
      &.add-video-btn {
        background: #04cbcd;
        border-radius: 24px;
        font-size: 16px;
        padding: 0 38px;
        line-height: 48px;
        height: 48px;
        border: 0;
        color: #fff;
        .icon {
          font-size: 26px;
          margin-right: 8px;
          padding-top: 6px;
        }
      }
    }
  }
  .scroll-text {
    text-align: center;
    line-height: 100px;
    color: #999;
  }
}
</style>
